import { PRIMARY_EVENT_COLOR } from '../../../constants';
import { ColorPickerModal } from '../../ColorPicker/ColorPickerModal';
import { AppointmentCardColorPreview } from './appointment-card-color-preview';
import { appointmentTypePrimaryColorPalette } from './appointment-type-color-palette';

type AppointmentTypeColorPickerProps = {
  disabled?: boolean;
  color: string;
  onChange: (color: string) => void;
  isLoading?: boolean;
  showToggle?: boolean;
};

export const AppointmentTypeColorPicker = ({
  disabled,
  color = PRIMARY_EVENT_COLOR,
  onChange,
  isLoading = false,
  showToggle = true,
}: AppointmentTypeColorPickerProps) => {
  return (
    <ColorPickerModal
      selectedColor={color ?? PRIMARY_EVENT_COLOR}
      onChange={onChange}
      palette={appointmentTypePrimaryColorPalette}
      gridColumns={9}
      disabled={disabled}
      showToggle={showToggle}
      isLoading={isLoading}
      closeOnSelect
    >
      <AppointmentCardColorPreview color={color ?? PRIMARY_EVENT_COLOR} />
    </ColorPickerModal>
  );
};
